import React from 'react';
import PropTypes from 'prop-types';

import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import app from '../../../app.module.css';
import form from '../../../commonStyles/formStyles.module.css';

const WarningMessage = ({ id, warning, check, onCheck }) => {
    if (!warning) return;
    return (
        <div
            className={`${form.fieldWarning} ${app.fadein} ${check ? `${form.fieldWarningChecked}` : ''}`}>
            {warning.message}
            <span
                className={form.checkCircle}
                onClick={() => onCheck(id, !check)}
                data-testid={`warning_check_${id}`}>
                {check ? <CheckCircleOutlineOutlinedIcon /> : <CancelOutlinedIcon />}
            </span>
        </div>
    );
};

WarningMessage.propTypes = {
    id: PropTypes.string,
    warning: PropTypes.object,
    check: PropTypes.bool,
    onCheck: PropTypes.func
};

export default WarningMessage;
